<div class="modal-header" hsDraggable="modal-dialog">
  <h4 class="modal-title">Create New Filter Group</h4>
  <button
    nf-icon-button
    icon="close"
    class="btn-bare"
    ngbTooltip="Close"
    (click)="activeModal.dismiss()"
  ></button>
</div>
<div class="modal-body pb-0" hsDraggable="modal-dialog">
  <nf-form-control label="Name" for="name" class="mb-0">
    <input
      type="text"
      ngbAutoFocus
      id="name"
      [(ngModel)]="name"
      class="form-control"
      [class.is-invalid]="nameError"
      (ngModelChange)="updateIsSubmitEnabled()"
    />
    <div class="invalid-feedback" *ngIf="nameError">
      {{ nameError }}
    </div>
  </nf-form-control>
  <nf-form-control label="Description" for="description" class="mb-0">
    <textarea
      id="description"
      [(ngModel)]="description"
      [rows]="4"
      class="form-control"
      [class.is-invalid]="descriptionError"
      (ngModelChange)="updateIsSubmitEnabled()"
    >
    </textarea>
    <div class="invalid-feedback" *ngIf="descriptionError">
      {{ descriptionError }}
    </div>
  </nf-form-control>
</div>
<div class="modal-footer" hsDraggable="modal-dialog">
  <button nf-button (click)="activeModal.dismiss()">Cancel</button>
  <button
    nf-button="save"
    (click)="onSave()"
    [disabled]="!isSubmitEnabled"
  ></button>
  <button
    nf-button="save"
    (click)="onSaveAndApply()"
    [disabled]="!isSubmitEnabled"
  >
    Save & Apply
  </button>
</div>
